import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import { BaseInfoProvider, QueryClientProvider } from '@/providers';
import { ErrorBoundary } from '@/components';
import { routes } from './router';
import { HelmetProvider } from 'react-helmet-async';
import zhCN from 'antd/es/locale/zh_CN';
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
dayjs.locale("zh-cn");

// @link-color: #1890ff; // 链接色
// @success-color: #52c41a; // 成功色
// @warning-color: #faad14; // 警告色
// @error-color: #f5222d; // 错误色
// @font-size-base: 14px; // 主字号
// @heading-color: rgba(0, 0, 0, 0.85); // 标题色
// @text-color: rgba(0, 0, 0, 0.65); // 主文本色
// @text-color-secondary: rgba(0, 0, 0, 0.45); // 次文本色
// @disabled-color: rgba(0, 0, 0, 0.25); // 失效色
// @border-radius-base: 2px; // 组件/浮层圆角
// @border-color-base: #d9d9d9; // 边框色
// @box-shadow-base: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08),
//   0 9px 28px 8px rgba(0, 0, 0, 0.05); // 浮层阴影

ConfigProvider.config({
  theme: {
    primaryColor: '#FF5600',
    infoColor: '#1677ff',
    successColor: '#52c41a',
    processingColor: '#FF5600',
    errorColor: '#ff4d4f',
    warningColor: '#faad14',
  },
});

const App = () => {
  const router = createBrowserRouter(routes, {
    // basename: '/new',
  });

  return (
    <ConfigProvider locale={zhCN}>
      <QueryClientProvider>
        <HelmetProvider>
          <ErrorBoundary>
            <BaseInfoProvider>
              <RouterProvider router={router} />
            </BaseInfoProvider>
          </ErrorBoundary>
        </HelmetProvider>
      </QueryClientProvider>
    </ConfigProvider>
  );
};

export default App;
